export default __webpack_public_path__ + "static/media/PNGearrings36.310fbc56.png";